import { render } from "./moengage-settings.vue?vue&type=template&id=0386aaf5&scoped=true"
import script from "./moengage-settings.vue?vue&type=script&lang=js"
export * from "./moengage-settings.vue?vue&type=script&lang=js"

import "./moengage-settings.vue?vue&type=style&index=0&id=0386aaf5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0386aaf5"]])

export default __exports__